{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "WhatsApp 範本",
      "SUBTITLE": "請選擇要發送的 WhatsApp 範本",
      "TEMPLATE_SELECTED_SUBTITLE": "設定範本：{templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "搜尋範本",
      "NO_TEMPLATES_FOUND": "找不到相符的範本",
      "HEADER": "標題",
      "BODY": "內文",
      "FOOTER": "頁尾",
      "BUTTONS": "按鈕",
      "CATEGORY": "類別",
      "MEDIA_CONTENT": "媒體內容",
      "MEDIA_CONTENT_FALLBACK": "媒體內容",
      "NO_TEMPLATES_AVAILABLE": "沒有可用的 WhatsApp 範本。點選重新整理以從 WhatsApp 同步範本。",
      "REFRESH_BUTTON": "重新整理範本",
      "REFRESH_SUCCESS": "已開始重新整理範本，可能需要幾分鐘才能完成更新。",
      "REFRESH_ERROR": "重新整理範本失敗，請重試。",
      "LABELS": {
        "LANGUAGE": "語言",
        "TEMPLATE_BODY": "範本內文",
        "CATEGORY": "類別"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "變數",
      "LANGUAGE": "語言",
      "CATEGORY": "類別",
      "VARIABLE_PLACEHOLDER": "輸入 {variable} 的值",
      "GO_BACK_LABEL": "返回",
      "SEND_MESSAGE_LABEL": "傳送訊息",
      "FORM_ERROR_MESSAGE": "傳送前請填寫所有變數",
      "MEDIA_HEADER_LABEL": "{type} 標題",
      "OTP_CODE": "輸入 4 至 8 位數的一次性密碼",
      "EXPIRY_MINUTES": "輸入到期分鐘數",
      "BUTTON_PARAMETERS": "按鈕參數",
      "BUTTON_LABEL": "按鈕 {index}",
      "COUPON_CODE": "輸入優惠碼（最多 15 個字元）",
      "MEDIA_URL_LABEL": "輸入 {type} URL",
      "DOCUMENT_NAME_PLACEHOLDER": "輸入文件檔名（例如 Invoice_2025.pdf）",
      "BUTTON_PARAMETER": "輸入按鈕參數"
    }
  }
}
